import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AnalyticsService } from './analytics.service';
import { ActionType } from './analytics.type';
import { Observable } from 'rxjs';

@Injectable()
export class HttpAnalyticsInterceptor implements HttpInterceptor {
  analytics = inject(AnalyticsService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url !== '/frontend-log') {
      this.analytics.add({
        actionType: ActionType.HTTP_REQUEST,
        httpRequest: {
          method: request.method,
          url: request.url,
        },
      });
    } else {
      this.analytics.add({
        actionType: ActionType.LOGS_SENT,
      });
    }
    return next.handle(request);
  }
}
